import './jquery-compat';

window.$ = window.jQuery = require('jquery');

import 'bootstrap';
import 'jquery-ui/ui/widgets/tabs.js';
import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/droppable.js';
import 'jquery-ui/ui/widgets/resizable.js';
import 'jquery-ui/ui/widgets/sortable.js';
import 'autocomplete.js/dist/autocomplete.jquery.min.js';
import { GridStack } from 'gridstack';
import autosize from 'autosize';

window.autosize = autosize;
window.GridStack = GridStack;

require('./components/ajax-loader.js');
require('./components/ajax-handler.js');
require('./components/navbar-search.js');

require('blueimp-file-upload');



$(document).ready(function() {
    $('[data-bs-toggle="tooltip"]').tooltip();
});

